import React, {useEffect, useState} from 'react';
import ConfirmModal from "components/ConfirmModal";
import RadioGroup from "components/Form/RadioGroup";
import {useOperator} from "context/OperatorContext";

export const UPDATE_MODES = {
    'ALL': 0,
    'SINGULAR': 1,
} as const;

export type UpdateMode = typeof UPDATE_MODES[keyof typeof UPDATE_MODES];

type UpdateEventModeProps = {
    show: boolean
    onSelectUpdateMode: (updateMode: UpdateMode) => any
    onCancel?: () => any
}

function UpdateEventMode({show, onSelectUpdateMode, onCancel}: UpdateEventModeProps) {
    const {termFor} = useOperator();
    const [updateMode, setUpdateMode] = useState<UpdateMode>(UPDATE_MODES.SINGULAR);

    useEffect(() => {
        setUpdateMode(UPDATE_MODES.SINGULAR);
    }, [show]);

    async function handleUpdateEvent() {
        onSelectUpdateMode(updateMode);
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.INFO}
            title={`Update repeating ${termFor('event')}`}
            // body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Update"
            onApprove={handleUpdateEvent}
            onCancel={handleCancel}
        >
            <RadioGroup
                label="Update Mode"
                selectedId={updateMode}
                items={[
                    {id: UPDATE_MODES.SINGULAR, name: `This ${termFor('event')} only`},
                    // {id: UPDATE_MODES.THIS_AND_FUTURE, name: `This and all following ${termFor('events')}`},
                    {id:
                        UPDATE_MODES.ALL,
                        name: `All ${termFor('events')}`,
                        description: (
                            <p className="text-xs text-red-500 pl-7">
                                {`IMPORTANT: This will apply these settings to ALL ${termFor('events')} in this series and overwrite any previous changes you have made to individual events.`}
                            </p>
                        )
                    },
                ]}
                onChange={(selectedId: number) => setUpdateMode(selectedId as UpdateMode)}
            />
        </ConfirmModal>
    );
}

export default UpdateEventMode;